<template>
    <v-container class="d-flex justify-center align-center" style="min-height: 100vh;">
      <v-card elevation="12" class="pa-6 rounded-xl" max-width="520" width="100%">
        <v-card-title class="text-h5 text-center font-weight-bold mb-2">
          🔐 Update Your Password
        </v-card-title>
        <p class="text-center text-subtitle-2 mb-4 grey--text">
          For your account's safety, use a strong and unique password.
        </p>
  
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="changePassword">
          <!-- Current Password -->
          <v-text-field
            v-model="currentPassword"
            :type="showCurrent ? 'text' : 'password'"
            label="Current Password"
            :append-icon="showCurrent ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showCurrent = !showCurrent"
            prepend-inner-icon="mdi-lock"
            outlined
            dense
            :rules="[v => !!v || 'Enter your current password']"
            class="mb-3"
          />
  
          <!-- New Password -->
          <v-text-field
            v-model="newPassword"
            :type="showNew ? 'text' : 'password'"
            label="New Password"
            :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showNew = !showNew"
            prepend-inner-icon="mdi-shield-key"
            outlined
            dense
            :rules="[v => v.length >= 8 || 'At least 8 characters required']"
            class="mb-1"
          />
          <div class="text-caption mb-4 grey--text">
            💡 Use a mix of letters, numbers & symbols for a stronger password.
          </div>
  
          <!-- Submit Button -->
          <v-btn
          style="background: linear-gradient(to bottom, #f2c46d, #3b5d58);"
            class="mt-1"
            dark
            block
            large
            elevation="2"
            :loading="loading"
            :disabled="!valid || loading"
            @click="changePassword"
          >
            <v-icon left>mdi-check</v-icon>
            Update Password
          </v-btn>
  
          <!-- Alert Feedback -->
          <v-alert
            v-if="statusMessage"
            :type="statusType"
            class="mt-5"
            dense
            border="start"
            colored-border
          >
            <v-icon left>
              {{ statusType === 'success' ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}
            </v-icon>
            {{ statusMessage }}
          </v-alert>
        </v-form>
      </v-card>
    </v-container>
  </template>  
  
  <script>
  import {
    getAuth,
    EmailAuthProvider,
    reauthenticateWithCredential,
    updatePassword,
  } from "firebase/auth";
  
  export default {
    name: "SecuritySettingsView",
    data() {
      return {
        valid: false,
        currentPassword: "",
        newPassword: "",
        showCurrent: false,
        showNew: false,
        loading: false,
        statusMessage: "",
        statusType: "",
      };
    },
    methods: {
      async changePassword() {
        this.statusMessage = "";
        this.statusType = "";
        this.loading = true;
  
        const auth = getAuth();
        const user = auth.currentUser;
        const email = user?.email;
  
        if (!user || !email) {
          this.statusMessage = "User not authenticated.";
          this.statusType = "error";
          this.loading = false;
          return;
        }
  
        try {
          const credential = EmailAuthProvider.credential(email, this.currentPassword);
          await reauthenticateWithCredential(user, credential);
          await updatePassword(user, this.newPassword);
  
          this.statusMessage = "Password updated successfully.";
          this.statusType = "success";
          this.currentPassword = "";
          this.newPassword = "";
  
          setTimeout(() => {
            this.$router.push("/member-settings");
          }, 1000);
        } catch (err) {
          this.statusMessage =
            err.code === "auth/wrong-password"
              ? "Incorrect current password."
              : `Failed to update password: ${err.message}`;
          this.statusType = "error";
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .headline {
    font-weight: 600;
    color: #2c2c2c;
  }
  </style>  